import React, { Component } from "react";
import LoadingPanel from "../../common/LoadingPanel";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { toolsController } from "../../../controllers/tools.controller";
import confirmService from "../../common/confirmService";
import { Form, Field } from "react-final-form";
import { LocalizationService } from "@progress/kendo-react-intl";
import { Button } from "@progress/kendo-react-buttons";
import { Localization } from "../../common/Localization";
import { Input } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum } from "../../../enums";

const formValidation = (values) => {
    const errors = {};

    if (!values.meno) {
        errors.meno = "Meno je povinná položka.";
    }
    if (!values.heslo) {
        errors.heslo = "Heslo je povinná položka.";
    }
    if (!values.celeMeno) {
        errors.celeMeno = "Celé meno je povinná položka.";
    }

    return errors;
};

const kendoHOC = (type, { input, meta, label, ...rest }) => {
    const Type = type;
    const LabelElement = type !== DropDownList ? "label" : "span";
    return (
        <LabelElement className="k-form-field">
            <span>{label}</span>
            <Type {...input} {...rest} />
            {meta.error && meta.touched && <span className="k-required">{meta.error}</span>}
        </LabelElement>
    );
};
const KendoInput = (options) => kendoHOC(Input, options);

class VytvorenieUzivatelovDialogContent extends Component {
    state = {
        result: null,
        loading: false,
        uzivatel: {
            meno: null,
            heslo: null,
            celeMeno: null
        }
    };

    componentDidMount() {}

    /**
     * Metoda, která je volána při odeslání formuláře.
     *
     * @memberof VytvorenieUzivatelovDialogContent
     */
    async onSubmit(values) {
        var localizationService = provideLocalizationService(this);

        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.QUESTION,
            message: localizationService.toLanguageString(
                "VytvorenieUzivatelov.Chcete vytvoriť užívateľov pre všetky predajne ?",
                "Chcete vytvoriť užívateľov pre všetky predajne ?"
            ),
            buttons: ButtonGroupEnum.OK_CANCEL,
            logMessage: true
        });
        if (confirmResult == ButtonMessageEnum.OK) {
            this.vytvorenieUzivatelov(values);
        }
    }

    vytvorenieUzivatelov(values) {
        var localizationService = provideLocalizationService(this);
        var dialog = document.getElementById("VytvorenieUzivatelovDialog");
        var button = dialog.getElementsByClassName("save-button")[0];
        button.disabled = true;
        toolsController.vytvorenieUzivatelov(values).then(async (response) => {
            if (response.errorMessage) {
                button.disabled = false;
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            } else {
                this.props.toggleDialog();
                var resultMessage = localizationService
                    .toLanguageString(
                        "VytvorenieUzivatelov.Užívateľ '<P1>' bol vytvorený pre <P2> predajní.",
                        "Užívateľ '<P1>' bol vytvorený pre <P2> predajní."
                    )
                    .replace("<P1>", values.meno)
                    .replace("<P2>", response.pocetUzivatelov);
                await confirmService.show({
                    type: MessageTypeEnum.INFORMATIVE,
                    message: resultMessage,
                    buttons: ButtonGroupEnum.OK,
                    logMessage: true
                });
            }
        });
    }

    renderDialogContent() {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="VytvorenieUzivatelovDialog">
                <Form
                    validate={formValidation}
                    onSubmit={async (values) => await this.onSubmit(values)}
                    initialValues={this.state.uzivatel}
                    render={({ form, handleSubmit, values }) => (
                        <React.Fragment>
                            <form id="VytvorenieUzivatelovForm" onSubmit={handleSubmit} className="k-form">
                                <fieldset>
                                    <Field
                                        name="meno"
                                        label={localizationService.toLanguageString("VytvorenieUzivatelov.Meno", "Meno")}
                                        component={KendoInput}
                                    />
                                    <Field
                                        name="heslo"
                                        label={localizationService.toLanguageString("VytvorenieUzivatelov.Heslo", "Heslo")}
                                        component={KendoInput}
                                    />
                                    <Field
                                        name="celeMeno"
                                        label={localizationService.toLanguageString("VytvorenieUzivatelov.Celé meno", "Celé meno")}
                                        component={KendoInput}
                                    />
                                </fieldset>
                            </form>
                            <div className="button-bar">
                                <Button icon="save" onClick={handleSubmit} className="auto-focus save-button">
                                    <Localization messageKey={"ToolsPage.Vytvorenie užívateľov"} defaultMessage={"Vytvorenie užívateľov"} />
                                </Button>
                            </div>
                        </React.Fragment>
                    )}
                />
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default VytvorenieUzivatelovDialogContent;



// WEBPACK FOOTER //
// ./src/components/views/Tools/VytvorenieUzivatelovDialogContent.js